export const fileConfig = {
    file: {
        audience: {
            type: {
                excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                text: 'text/plain'
            },
            maxSize: 10485760
        }
    }
}